export const name = 're-buy-giftcard'

// generic setup
import {
  allValidationsRules as validationsRules,
  defaultFormFields,
  parseValidations,
  parseValidationSetup
} from './form'

import props from './props'

export {props, defaultFormFields, validationsRules, parseValidations, parseValidationSetup}

// noinspection NpmUsedModulesInstalled
import GiftcardFormMixin from '../../../../mixins/external/giftcard-form'
import StepsMixin from './steps'
import LocationMixin from './location'
import QuantityMixin from './quantity'
import CartMixins from '../../../../mixins/cart'
import ComponentMixin from '../../../../mixins/components/complex-reactive'
import FormMixin from '../../../../mixins/form'
import FormForceUpdateMixin from '../../../../mixins/form/force-update-onload'
import ProductsFilterMixin from '../../../../mixins/store/products-filter'
import DesignerMixin from './designer'
export const mixins = [
  ComponentMixin,
  StepsMixin,
  FormMixin,
  GiftcardFormMixin,
  CartMixins,
  FormForceUpdateMixin,
  ProductsFilterMixin,
  LocationMixin,
  QuantityMixin,
  DesignerMixin
]

export const EventBus = window.VueEventBus

// data
const propDefs = props
export const data = {
  propDefs,
}

export default {
  name,
  mixins,
  props,
  data,

  validationsRules,
  defaultFormFields,
  parseValidations,
  parseValidationSetup,

  EventBus
}
